const quickLinks = [
  { href: '#today', label: '今日更新' },
  { href: '#ranking', label: '热门榜单' },
  { href: '#editor', label: '编辑推荐' },
  { href: '#new', label: '新作首发' },
];

const genreLinks = ['热血战斗', '恋爱治愈', '科幻机甲', '悬疑推理', '古风仙侠', '日常轻松'];

export default function Footer() {
  return (
    <footer className="bg-background-900 px-4 pb-8 pt-12 text-background-100 md:px-6">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" className="font-heading flex items-center gap-2 text-2xl text-background-50">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              动漫第一页
            </a>
            <p className="mt-3 max-w-md text-sm leading-6 text-background-300">
              卡通动漫第一页聚合今日更新、热门榜单、编辑推荐、新作首发、高分漫画与人气连载，
              让每一位漫画迷都能轻松找到想看的作品，每日推荐不重样。
            </p>
            <div className="mt-4 flex items-center gap-3 text-background-200">
              <span className="text-xs">追更，从这里开始</span>
              <span className="h-px flex-1 max-w-[120px] bg-background-700"></span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">快速导航</h4>
            <ul className="mt-3 space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-300 hover:text-primary-400">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">热门题材</h4>
            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2">
              {genreLinks.map((g) => (
                <li key={g}>
                  <a href="#today" className="text-sm text-background-300 hover:text-primary-400">
                    {g}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-700 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 卡通动漫第一页 · 只为热爱漫画的你
          </p>
          <p className="text-xs text-background-400">
            联系邮箱：{' '}
            <a
              href="mailto:hello@dongman-first.example"
              className="text-background-300 hover:text-primary-400"
            >
              hello@dongman-first.example
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}